















import Vue from "vue";
import MarkdownIt from "markdown-it";

const md = new MarkdownIt({ breaks: true });

interface Props {
  releaseTitle: string;
  releaseVersion: string;
  releaseDate: string;
  markdownContent: string;
  scope: string;
}

interface Computed {
  renderedBody: string;
}

export default Vue.extend<Record<string, never>, Record<string, never>, Computed, Props>({
  name: "ReleaseNoteCard",

  props: {
    releaseTitle: { type: String, default: "" },
    releaseVersion: { type: String, default: "" },
    releaseDate: { type: String, default: "" },
    markdownContent: { type: String, default: "" },
    scope: { type: String, default: "" }
  },

  computed: {
    renderedBody(): string {
      return this.markdownContent ? md.render(this.markdownContent) : "";
    }
  }
});
